// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

// Import only the components you use
import {
  VApp,
  VAppBar,
  VAppBarTitle,
  VAppBarNavIcon,
  VBtn,
  VCard,
  VCardActions,
  VCardItem,
  VCardSubtitle,
  VCardText,
  VCardTitle,
  VChip,
  VChipGroup,
  VCol,
  VContainer,
  VDataTable,
  VDialog,
  VDivider,
  VExpandTransition,
  VForm,
  VIcon,
  VList,
  VListGroup,
  VListItem,
  VListItemTitle,
  VListItemSubtitle,
  VMain,
  VNavigationDrawer,
  VRow,
  VSelect,
  VSheet,
  VSpacer,
  VTable,
  VTextField,
  VToolbar,
  VToolbarTitle,
  VAlert,
  VProgressLinear,
  VSnackbar,
  VTooltip,
  VMenu,
  VAutocomplete,
  VCheckbox,
  VRadio,
  VRadioGroup,
  VTextarea,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelTitle,
  VExpansionPanelText,
  VTab,
  VTabs,
  VWindow,
  VWindowItem,
  VListSubheader,
  VSkeletonLoader,
  VImg,
  VAvatar,
  VBtnGroup,
  VPagination,
  VFileInput,
  VSlider,
  VAlertTitle,
  VProgressCircular,
  VSwitch,
  VBtnToggle,
  VTimeline,
  VTimelineItem,
  VCheckboxBtn,
  VCombobox,
  VHover,
  VLabel,
  VTabsWindow,
  VTabsWindowItem,
  VOverlay,
  VStepper,
  VStepperHeader,
  VStepperItem,
  VStepperWindow,
  VStepperWindowItem,
  VFooter
} from 'vuetify/components'
import {
  VFadeTransition
} from 'vuetify/components/transitions'

// Import only the directives you use
import {
  Ripple,
  Intersect,
  Resize
} from 'vuetify/directives'

export default createVuetify({
  components: {
    VApp,
    VAppBar,
    VAppBarTitle,
    VAppBarNavIcon,
    VBtn,
    VCard,
    VCardActions,
    VCardItem,
    VCardSubtitle,
    VCardText,
    VCardTitle,
    VChip,
    VChipGroup,
    VCol,
    VContainer,
    VDataTable,
    VDialog,
    VDivider,
    VExpandTransition,
    VForm,
    VIcon,
    VList,
    VListGroup,
    VListItem,
    VListItemTitle,
    VListItemSubtitle,
    VMain,
    VNavigationDrawer,
    VRow,
    VSelect,
    VSheet,
    VSpacer,
    VTable,
    VTextField,
    VToolbar,
    VToolbarTitle,
    VAlert,
    VProgressLinear,
    VSnackbar,
    VTooltip,
    VMenu,
    VAutocomplete,
    VCheckbox,
    VRadio,
    VRadioGroup,
    VTextarea,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelTitle,
    VExpansionPanelText,
    VTab,
    VTabs,
    VWindow,
    VWindowItem,
    VListSubheader,
    VSkeletonLoader,
    VImg,
    VAvatar,
    VBtnGroup,
    VPagination,
    VFileInput,
    VSlider,
    VAlertTitle,
    VProgressCircular,
    VSwitch,
    VBtnToggle,
    VTimeline,
    VTimelineItem,
    VCheckboxBtn,
    VCombobox,
    VHover,
    VLabel,
    VTabsWindow,
    VTabsWindowItem,
    VFadeTransition,
    VOverlay,
    VStepper,
    VStepperHeader,
    VStepperItem,
    VStepperWindow,
    VStepperWindowItem,
    VFooter
  },
  directives: {
    Ripple,
    Intersect,
    Resize
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#EB661F',        // --banjino-orange
          secondary: '#285338',      // --banjino-green
          accent: '#F3D69C',         // --banjino-tan
          error: '#D32F2F',          // --banjino-error
          info: '#767934',           // --banjino-olive
          success: '#4CAF50',        // Standard success green
          warning: '#FF9800',        // Standard warning orange
        },
      },
    },
  },
  defaults: {
    VBtn: {
      variant: 'flat',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    }
  }
})